// @ts-nocheck
import {Column} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {SelectionHeader} from './SelectionHeader'
import {User} from '../../core/_models'
import {CustonCell} from './CustonCell'
import {formatMask, formatMonetaryToBr} from '../../../../../../../utils/formatMonetaryToBr'
import {formatDateTime} from '../../../../../../../utils/dayJs/format'

const ReportSalesColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <CustomHeader tableProps={props} title='Contrato' className='min-w-125px' />,
    id: 'contract',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].contract} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Cliente' className='min-w-125px' />,
    id: 'clientName',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].clientName} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-125px' />,
    id: 'statusName',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].statusName} />,
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Dt Contrato' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({...props}) => (
      <CustonCell value={formatDateTime(props.data[props.row.index].createdAt)} />
    ),
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Unid Contrato' className='min-w-50px' />
    ),
    id: 'franchiseName',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].franchiseName} />,
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Categoria' className='min-w-125px' />
    ),
    id: 'categoryName',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].categoryName} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Num Area' className='min-w-125px' />,
    id: 'productId',
    Cell: ({...props}) => <CustonCell value={`${props.data[props.row.index].productId}`} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Desc Area' className='min-w-125px' />
    ),
    id: 'productName',
    Cell: ({...props}) => <CustonCell value={`${props.data[props.row.index].productName}`} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Qte' />,
    id: 'sessions',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].sessions} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Tp' />,
    id: 'type',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].type} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Preço' className='min-w-125px' />,
    id: 'price',
    Cell: ({...props}) => <CustonCell value={formatMask(props.data[props.row.index].price)} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Desconto' className='min-w-125px' />,
    id: 'discount',
    Cell: ({...props}) => <CustonCell value={formatMask(props.data[props.row.index].discount)} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Crédito Voucher' className='min-w-125px' />
    ),
    id: 'voucherCredit',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].voucherCredit)} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Valor Total Faturável' className='min-w-125px' />
    ),
    id: 'totalPrice',
    Cell: ({...props}) => <CustonCell value={formatMask(props.data[props.row.index].totalPrice)} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Funcionário' className='min-w-125px' />
    ),
    id: 'sellerName',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].sellerName} />,
  },
]

export {ReportSalesColumns}
